// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-icon {
  position: relative;
  cursor: pointer;
  padding: 8px;
  color: #718096;
  transition: color 0.2s ease;
}

.notification-icon:hover {
  color: #4361ee;
}

.notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #ef4444;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 0.75rem;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
}

.notifications-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 380px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 50;
  max-height: 400px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.notifications-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  background: white;
}

.notifications-list {
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.notifications-title {
  font-weight: 600;
  color: #1a202c;
}

.mark-all-read {
  color: #4361ee;
  font-size: 0.875rem;
  cursor: pointer;
}

.notification-item {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.notification-item:hover {
  background-color: #f7fafc;
}

.notification-item.unread {
  background-color: #ebf4ff;
}

.notification-content {
  flex: 1 1;
  min-width: 0;
}

.notification-item-close {
  background: none;
  border: none;
  padding: 4px;
  color: #a0aec0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.notification-item-close:hover {
  background-color: #f1f5f9;
  color: #e53e3e;
}

.notification-message {
  color: #4a5568;
  font-size: 0.875rem;
  line-height: 1.25rem;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.notification-time {
  color: #718096;
  font-size: 0.75rem;
  margin-top: 4px;
}

.notification-dot {
  width: 8px;
  height: 8px;
  background-color: #4361ee;
  border-radius: 50%;
  margin-top: 6px;
}

.empty-notifications {
  padding: 32px 16px;
  text-align: center;
  color: #718096;
}
`, "",{"version":3,"sources":["webpack://./src/styles/notifications.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;EAC/C,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".notification-icon {\n  position: relative;\n  cursor: pointer;\n  padding: 8px;\n  color: #718096;\n  transition: color 0.2s ease;\n}\n\n.notification-icon:hover {\n  color: #4361ee;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: #ef4444;\n  color: white;\n  border-radius: 50%;\n  padding: 2px 6px;\n  font-size: 0.75rem;\n  min-width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #ffffff;\n}\n\n.notifications-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 380px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  z-index: 50;\n  max-height: 400px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.notifications-header {\n  padding: 16px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  background: white;\n}\n\n.notifications-list {\n  overflow-x: hidden;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.notifications-title {\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.mark-all-read {\n  color: #4361ee;\n  font-size: 0.875rem;\n  cursor: pointer;\n}\n\n.notification-item {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e2e8f0;\n  transition: background-color 0.2s ease;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.notification-item:hover {\n  background-color: #f7fafc;\n}\n\n.notification-item.unread {\n  background-color: #ebf4ff;\n}\n\n.notification-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-item-close {\n  background: none;\n  border: none;\n  padding: 4px;\n  color: #a0aec0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.notification-item-close:hover {\n  background-color: #f1f5f9;\n  color: #e53e3e;\n}\n\n.notification-message {\n  color: #4a5568;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.notification-time {\n  color: #718096;\n  font-size: 0.75rem;\n  margin-top: 4px;\n}\n\n.notification-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #4361ee;\n  border-radius: 50%;\n  margin-top: 6px;\n}\n\n.empty-notifications {\n  padding: 32px 16px;\n  text-align: center;\n  color: #718096;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
